import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { HttpHeaders } from "@angular/common/http";

import { filter, map, Observable, share } from "rxjs";

import { Product, ProductContainer } from '@shared/models';
import {
  AddProductCommand,
  UpdateProductCommand,
  AddProductContainerCommand,
  UpdateProductContainerCommand,
  DeActivateProductContainerCommand,
} from "@shared/models/commands";

import { AbstractApiServiceBase } from "./abstract-data.service";




@Injectable({ providedIn: 'root' })
export class ProductsDataService extends AbstractApiServiceBase {

  public getProducts(): Observable<Product[]> {
    const url: string = `${this.getBaseApiUrl()}/products/all`;

    return this.http.get<Product[]>(url)
      .pipe(share(), map(items => items.map(item => new Product(item))));
  }

  public addProduct(command: AddProductCommand): Observable<Product> {
    const body = JSON.stringify(command);
    const headers = this.getJsonHeader();

    return this.http.post<Product>(`${this.getBaseApiUrl()}/products`, body, { headers: headers })
      .pipe(map(response => new Product(response)));
  }

  public updateProduct(command: UpdateProductCommand): Observable<Product> {
    const body = JSON.stringify(command);
    const headers = this.getJsonHeader();

    return this.http.put<Product>(`${this.getBaseApiUrl()}/products/${command.productCode}/update`, body, { headers: headers })
      .pipe(map(response => new Product(response)));
  }

  public removeProduct(productCode: string): Observable<void> {
    return this.http.delete<void>(`${this.getBaseApiUrl()}/products/${productCode}`);
  }

  public getProductContainers(
    shouldIncludeInActive: boolean = true,
    filterByDeviceId: string | null = null): Observable<ProductContainer[]> {
    let url: string = `${this.getBaseApiUrl()}/product-containers/all?shouldIncludeInActive=${shouldIncludeInActive}`;
    if (filterByDeviceId) {
      url += `&filterByDeviceId=${filterByDeviceId}`;
    }

    return this.http.get<ProductContainer[]>(url).pipe(share());
  }

  public addProductContainer(command: AddProductContainerCommand): Observable<ProductContainer> {
    const body = JSON.stringify(command);
    const headers = this.getJsonHeader();

    return this.http.post<ProductContainer>(`${this.getBaseApiUrl()}/product-containers`, body, { headers: headers })
      .pipe(map(response => { return response; }));
  }

  public deActivateProductContainer(command: DeActivateProductContainerCommand): Observable<ProductContainer> {
    const headers = this.getJsonHeader();

    return this.http.delete<ProductContainer>(
      `${this.getBaseApiUrl()}/product-containers/${command.productCode}?containerCode=${command.containerCode}`,
      { headers }).pipe(map(response => { return response }));
  }

  public updateProductContainer(command: UpdateProductContainerCommand): Observable<ProductContainer> {
    const url = `${this.getBaseApiUrl()}/product-containers/${command.productContainerId}/update`;
    const body = JSON.stringify(command);
    const headers = this.getJsonHeader();
    return this.http.put<ProductContainer>(url, body, { headers }).pipe(share());
  }

  public exportProducts(): Observable<Blob> {
    const url = `${this.getBaseApiUrl()}/products/export`;
    return this.http.get(url, { responseType: 'blob' });
  }

  public importProducts(file: File): Observable<any> {
    const url = `${this.getBaseApiUrl()}/products/import`;
    const formData = new FormData();
    formData.append('file', file);
    const headers = new HttpHeaders();
    return this.http.post<any>(url, formData, { headers });
  }

  public exportProductContainers(): Observable<Blob> {
    const url = `${this.getBaseApiUrl()}/product-containers/export`;
    return this.http.get(url, { responseType: 'blob' });
  }

  public importProductContainers(file: File): Observable<any> {
    const url = `${this.getBaseApiUrl()}/product-containers/import`;
    const formData = new FormData();
    formData.append('file', file);
    const headers = new HttpHeaders();
    return this.http.post<any>(url, formData, { headers });
  }
}
